import clsx from "clsx";
import { useEffect, useState } from "react";

import { useMainContext } from "../../../context";
import { Answer, Question } from "../../../types/api";
import { FormTextValue } from "../../../types/context";
import { autoScroll } from "../../../utils/autoScroll";
import { validate } from "../../../utils/validation";

type Props = { question: Question; answer: Answer };
export const TextInput = ({ question, answer }: Props) => {
  const { form, handleTextInput } = useMainContext();

  const [isValidationActive, setIsValidationActive] = useState(false);
  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
    const timer = setTimeout(() => {
      autoScroll()
    }, 400)

    return () => clearTimeout(timer)
  }, [inputValue])

  const valid = validate(
    (form[question.questionId].value as FormTextValue)[answer.answerId].value,
    answer.validation
  );

  return (
    <input
      key={answer.answerId}
      className={clsx(
        isValidationActive && !valid ? "step__input_notValid" : "step__input"
      )}
      placeholder={answer.answerName + "*"}
      value={
        (form[question.questionId].value as FormTextValue)[answer.answerId]
          .value
      }
      onChange={(e) =>{
        handleTextInput(question, answer.answerId, e.target.value, answer)
        setInputValue(e.target.value)
      }
      
      }
      onBlur={() => {
        if (!isValidationActive) {
          setIsValidationActive(true);
        }
      }}
    />
  );
};
